export const sa_event = window.sa_event;